window.addEventListener('DOMContentLoaded', (event) => {

    // Logout on click
    const logoutBtn = document.body.querySelector("#logout-form-btn");
    if (logoutBtn) {
        logoutBtn.addEventListener('click', (event) => {
            event.preventDefault();
            document.getElementById('logout-form').submit();
        });
    }

    // Resend OTP on click
    const resendBtn = document.body.querySelector("#resend-otp-btn");
    if (resendBtn) {
        resendBtn.addEventListener('click', (event) => {
            event.preventDefault();
            document.getElementById('resend-otp').submit();
        });
    }

});